import { api, createErrorResponse } from './index';

import {
  ADMIN_ROUTE_PREFIX,
  POSTMARK_HOSTNAME,
  POSTMARK_FROM,
  POSTMARK_FORGOT_PASSWORD_TEMPLATE_ID,
  POSTMARK_INVITE_TEMPLATE_ID,
  POSTMARK_CREATE_ACCOUNT_TEMPLATE_ID,
  POSTMARK_CHANGE_PASSWORD_TEMPLATE_ID,
} from './constants';

export async function getAllUsers() {
  try {
    const response = await api.get(`${ADMIN_ROUTE_PREFIX}/users`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function getUsersById(uuid) {
  try {
    const response = await api.get(`${ADMIN_ROUTE_PREFIX}/users/${uuid}`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function deleteUserById(uuid) {
  try {
    const response = await api.delete(`${ADMIN_ROUTE_PREFIX}/users/${uuid}`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function inviteUsers(
  invites,
  hostname = POSTMARK_HOSTNAME,
  templateId = POSTMARK_INVITE_TEMPLATE_ID,
  fromEmail = POSTMARK_FROM,
) {
  try {
    const response = await api.post(`${ADMIN_ROUTE_PREFIX}/users/invite`, {
      'account-invitations': invites,
      hostname,
      templateId: +templateId,
      fromEmail,
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function verifyInviteToken(email, token) {
  try {
    const response = await api.get(
      `check-account-invite-creds/${email}/${token}`,
    );
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function verifyResetToken(email, token) {
  try {
    const response = await api.get(
      `check-password-reset-creds/${email}/${token}`,
    );
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function claimAccount(
  userData,
  hostname = POSTMARK_HOSTNAME,
  templateId = POSTMARK_CREATE_ACCOUNT_TEMPLATE_ID,
  fromEmail = POSTMARK_FROM,
) {
  try {
    const response = await api.post(`claim-account-invite`, {
      ...userData,
      hostname,
      templateId: +templateId,
      fromEmail,
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function postPassword(
  data,
  hostname = POSTMARK_HOSTNAME,
  templateId = POSTMARK_CHANGE_PASSWORD_TEMPLATE_ID,
  fromEmail = POSTMARK_FROM,
) {
  try {
    const response = await api.post(`reset-password`, {
      ...data,
      hostname,
      templateId: +templateId,
      fromEmail,
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function postPasswordReset(
  email,
  hostname = POSTMARK_HOSTNAME,
  templateId = POSTMARK_FORGOT_PASSWORD_TEMPLATE_ID,
  fromEmail = POSTMARK_FROM,
) {
  try {
    const response = await api.post(`send-password-reset`, {
      email,
      hostname,
      templateId: +templateId,
      fromEmail,
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function updateUsers(users) {
  try {
    const response = await api.post(`${ADMIN_ROUTE_PREFIX}/users`, {
      users,
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function deleteRoleFromUserByUuid(uuid, role) {
  try {
    const response = await api.delete(`${ADMIN_ROUTE_PREFIX}/users/${uuid}/role/${role}`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}
